<template>
  <div>
    <GoogleMap v-if="availableProviders && availableProviders.length" :providers="availableProviders"
      :selectedProvider="selectedProvider" @change="onChange">
      <div class="provider-select-wrap">
        <label class="input-top-label">{{ t.getOrKey('Label.SelectProvider') }}</label>
        <v-select :options="availableProviders" label="name" @input="selectValueChanged" v-model="selectedProvider">
          <template v-slot:option="option">
            <div class="provider-select-item">
              <div>{{ option.name }}</div>
              <div>{{ option.street }} {{ option.city }}</div>
            </div>
          </template>
        </v-select>
      </div>
    </GoogleMap>
    <div v-if="availableProviders && availableProviders.length === 0">{{ t.getOrKey('Label.NoProviderWithServices') }}
    </div>
  </div>
</template>
<script>
import api from "@/services/api-service";
import GoogleMap from "./GoogleMap.vue";
import t from "@/services/translation-service";
import utils from './../services/utils';
export default {
  name: "ProviderSelector",
  props: {
    selectedServices: Array,
    system: String,
    reference: String,
  },
  watch: {
    selectedServices(newVal, oldVal) {
      if (!utils.arrayContainsIdenticalItems(newVal, oldVal)) {
        this.updateProviders();
      }

    },
  },
  components: {
    GoogleMap,
  },
  data() {
    return {
      loading: true,
      availableProviders: [],
      selectedProvider: undefined,
      t: t,
      initialChecked: false,
    };
  },
  methods: {
    updateProviders() {
      this.loading = true;
      return api
        .getProviders(this.selectedServices)
        .then((data) => {
          this.availableProviders = data;
          return this.availableProviders;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    clearData() {
      this.onChange(undefined);
    },
    closestProviders(provider){
      const lon1 = Number(provider?.coordinates?.lon);
      const lat1 = Number(provider?.coordinates?.lat);
      if(!Number.isNaN(lon1) && !Number.isNaN(lat1)){
          const closeProviders = this.availableProviders.map(p => {
            const lon2 = Number(p?.coordinates?.lon);
            const lat2 = Number(p?.coordinates?.lat);
            if(!Number.isNaN(lon2) && !Number.isNaN(lat2)){
              const dist = utils.distance(lat1, lon1, lat2, lon2);
              return {...p, distance: dist};
            }            
            return p;
          }).filter(f => !!f.distance).sort((a,b) => a.distance - b.distance);
           return closeProviders;
      }
      return [];
    },
    onChange(provider) {
      this.selectedProvider = provider;
      const otherProviders = this.closestProviders(provider) ?? [];
      this.$emit("change", provider, otherProviders);
    },
    selectValueChanged(provider) {
      if (this.selectedProvider && this.selectedProvider.id === provider.id) {
        return;
      }
    },
    setProvider(provider){
      this.selectedProvider = provider;
    }
  },
  created() {
    if (this.system && this.reference) {
      this.updateProviders().then(() => {
        const p = this.availableProviders.find((f) =>
          f.references.some(
            (g) => g.system === this.system && g.reference === this.reference
          )
        );
        this.onChange(p);
      });
    }
  },
};
</script>
<style>
.provider-select-item {
  padding: 1rem 0;
  border-bottom: 1px solid lightgray;
}

.provider-select-wrap {
  width: 100%;
}
</style>
